var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { KlevuConfig } from "../config.js";
export function get(url, ignoreResult = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const axios = KlevuConfig.getDefault().axios;
        if (axios) {
            return (yield axios.get(url)).data;
        }
        const res = yield fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (ignoreResult) {
            return undefined;
        }
        return (yield res.json());
    });
}
export function post(url, data, ignoreResult = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const sendAsFormData = data instanceof FormData;
        const axios = KlevuConfig.getDefault().axios;
        if (axios) {
            try {
                const res = yield axios.post(url, data, {
                    headers: sendAsFormData
                        ? undefined
                        : {
                            "Content-Type": "application/json",
                        },
                });
                return res.data;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }
            catch (error) {
                return error.response.data;
            }
        }
        // Fetch will always return value. Even with 500 errors.
        const res = yield fetch(url, {
            method: "POST",
            headers: sendAsFormData
                ? undefined
                : {
                    "Content-Type": "application/json",
                },
            body: sendAsFormData ? data : JSON.stringify(data),
        });
        if (ignoreResult) {
            return undefined;
        }
        return (yield res.json());
    });
}
